<script setup lang="ts">
import BaseSvg from './BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-copy" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g fill="currentColor" fill-rule="evenodd" clip-path="url(#a)" clip-rule="evenodd">
      <path
        d="M9 3.5h8c.28 0 .5.22.5.5v8a.5.5 0 0 1-.5.5h-2.25a.76.76 0 0 0-.75.75c0 .41.34.75.75.75H17a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v.47c0 .41.34.75.75.75s.75-.34.75-.75V4c0-.28.22-.5.5-.5Z"
      />
      <path
        d="M11 7.5H3a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5ZM3 6a2 2 0 0 0-2 2v8c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H3Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h18v16H0z" transform="translate(1 2)" />
      </clipPath>
    </defs>
  </BaseSvg>
</template>
